window.bootstrap = require('bootstrap');

import Swiper from "swiper/bundle";
import "swiper/css/bundle";

import anime from 'animejs';

import AOS from 'aos';
import 'aos/dist/aos.css';

if (window.innerWidth >= 992) {
    setTimeout(() => {
        AOS.init();
    }, 500);
} else {
    document.querySelectorAll("[data-aos]").forEach(el => {
        el.removeAttribute("data-aos"); // Remove AOS attributes on smaller screens
    });
}


import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";



// Accordion
document.addEventListener('DOMContentLoaded', () => {
    const accordionCollapses = document.querySelectorAll('.accordion-collapse');
    accordionCollapses.forEach(collapse => {
        if (collapse.classList.contains('show')) {
            const accordionItem = collapse.closest('.accordion-item');
            accordionItem.classList.add('is-expanded');
        }
        collapse.addEventListener('show.bs.collapse', () => {
            const accordionItem = collapse.closest('.accordion-item');
            accordionItem.classList.add('is-expanded');
        });
        collapse.addEventListener('hide.bs.collapse', () => {
            const accordionItem = collapse.closest('.accordion-item');
            accordionItem.classList.remove('is-expanded');
        });
    });
});



// Adjust circle's height based on their width
// function updateElementsHeight(selector) {
//     const elements = document.querySelectorAll(selector);
//     if (elements.length > 0) {
//         elements.forEach(element => {
//             const elementWidth = element.offsetWidth;
//             if (elementWidth > 0) {
//                 element.style.height = `${elementWidth}px`;
//             }
//         });
//     }
// }
// function updateAllHeights() {
//     updateElementsHeight('.o-four-circles__wrapper__circle');
//     updateElementsHeight('.m-circle-extend');
//     updateElementsHeight('.o-team__intro');
// }
// window.addEventListener('resize', updateAllHeights);
// window.dispatchEvent(new Event('resize'));



// ANIMATION - banner hotspot, story telling image and story telling big blue circle
document.addEventListener("DOMContentLoaded", () => {
    const storytellingElements = [
        ...document.querySelectorAll(".o-storytelling__wrapper__image"),
        ...document.querySelectorAll(".o-storytelling__wrapper__content-wrapper"),
        ...document.querySelectorAll(".o-banner .hotspot"),
        ...document.querySelectorAll(".o-text-module-3-columns .img"),
        ...document.querySelectorAll(".o-story-slider__image"),
    ];

    function initAnimations() {
        if (window.innerWidth < 992) {
            storytellingElements.forEach((el) => el.classList.remove("animate"));
            return;
        }

        if (storytellingElements.length) {
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            entry.target.classList.add("animate");
                            observer.unobserve(entry.target);
                        }
                    });
                },
                {
                    threshold: 0.4,
                }
            );

            storytellingElements.forEach((element) => {
                if (element.classList.contains("o-storytelling__wrapper__content-wrapper")) {
                    const customObserver = new IntersectionObserver(
                        (entries) => {
                            entries.forEach((entry) => {
                                if (entry.isIntersecting) {
                                    entry.target.classList.add("animate");
                                    customObserver.unobserve(entry.target);
                                }
                            });
                        },
                        {
                            threshold: 0.1,
                        }
                    );
                    customObserver.observe(element);
                } else {
                    observer.observe(element);
                }
            });
        }
    }
    initAnimations();
    window.addEventListener("resize", initAnimations);
});



// HEADER - change the height of header when the dropdown menu appears on hover
document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.o-header');
    const logo = document.querySelector('.o-header__logo');
    const dropdowns = document.querySelectorAll('.dropdown');
    let hoverTimeout;
    const isLargeScreen = window.innerWidth > 992;

    function handleDropdown(dropdown, dropdownMenu) {
        dropdown.addEventListener('mouseenter', () => {
            if (!isLargeScreen) return;

            const dropdownHeight = dropdownMenu.offsetHeight || 0;
            const extraPadding = 150 - header.offsetHeight;

            // Apply extra padding to header
            header.style.paddingBottom = `${dropdownHeight + extraPadding}px`;

            // Delay only the dropdown appearance
            hoverTimeout = setTimeout(() => {
                dropdownMenu.classList.add('active');
            }, 200);
        });

        dropdown.addEventListener('mouseleave', () => {
            if (!isLargeScreen) return;
            clearTimeout(hoverTimeout);

            dropdownMenu.classList.remove('active');
            header.style.paddingBottom = '';
        });
    }

    function centerLogo(dropdown, dropdownMenu) {
        dropdown.addEventListener('mouseenter', () => {
            if (!isLargeScreen) return;

            requestAnimationFrame(() => {
                const headerHeight = header.offsetHeight;
                const logoHeight = logo.offsetHeight;
                const translateY = (headerHeight - logoHeight) / 2;
                logo.style.transform = `translateY(${translateY}px)`;
            });
        });

        dropdown.addEventListener('mouseleave', () => {
            if (!isLargeScreen) return;
            logo.style.transform = '';
        });
    }

    function initializeDropdowns() {
        dropdowns.forEach(dropdown => {
            const dropdownMenu = dropdown.querySelector('.sub-menu');
            if (dropdownMenu) {
                handleDropdown(dropdown, dropdownMenu);
                centerLogo(dropdown, dropdownMenu);
            }
        });
    }

    if (isLargeScreen) {
        initializeDropdowns();
    }

    window.addEventListener('resize', () => {
        if (window.innerWidth > 992 && !isLargeScreen) {
            initializeDropdowns();
        } else if (window.innerWidth <= 992 && isLargeScreen) {
            header.style.paddingBottom = '';
            logo.style.transform = '';
            dropdowns.forEach(dropdown => {
                const dropdownMenu = dropdown.querySelector('.sub-menu');
                if (dropdownMenu) {
                    dropdownMenu.classList.remove('active');
                }
            });
        }
    });
});



// Mobile menu
document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.o-header');
    const mobileMenuButton = document.querySelector('.o-header__mobile-menu');
    const html = document.documentElement;

    if (!mobileMenuButton || !header) return;
    function updateMobileMenuPosition() {
        if (header.classList.contains('o-header--mobile')) {
            let headerHeight = header.offsetHeight;
            let mobileMenu = document.querySelector('.o-header--mobile ul');

            if (mobileMenu) {
                mobileMenu.style.top = `${headerHeight}px`;
            }
        }
    }
    mobileMenuButton.addEventListener('click', () => {
        if (window.innerWidth <= 992) {
            header.classList.toggle('o-header--mobile');
            html.classList.toggle('overflow-hidden');
            updateMobileMenuPosition();
        }
    });
    window.addEventListener('resize', updateMobileMenuPosition);
});



// Mouseover circles
document.addEventListener("DOMContentLoaded", function () {
    const circleWrapper = document.querySelector(".o-extended-circles");
    const smallCircles = document.querySelectorAll(".m-circle-extend");
    const largeCircle = document.querySelector(".m-circle-large");
    const largeCircleTitle = largeCircle.querySelector(".m-circle-large__title");
    const largeCirclePhase = largeCircle.querySelector(".m-circle-large__phase");
    const largeCircleContent = largeCircle.querySelector(".m-circle-extend__content");
    const largeCircleLink = largeCircle.querySelector(".m-circle-large__link");
    const wrapperCircle = document.querySelector(".m-circle-large__wrapper");
    // let initAnimation = false
    let isAnimating = false;

    smallCircles.forEach(circle => {
        circle.addEventListener("click", function () {
            if (isAnimating) return;
            isAnimating = true;

            !circleWrapper.classList.contains('active') && circleWrapper.classList.add('active')
            !wrapperCircle.classList.contains("active") && wrapperCircle.classList.add("active");

            largeCircle.classList.remove("visible");
            updateLargeCircleContent(circle);
            showLargeCircle(circle);
            setTimeout(() => {
                isAnimating = false;
            }, 500);
        });
    });

    function updateLargeCircleContent(circle) {
        const title = circle.querySelector(".f-xl")?.innerText || "";
        const phase = circle.querySelector(".f-small")?.innerText || "";
        const content = circle.querySelector(".m-circle-extend__content")?.innerHTML || "";
        const link = circle.querySelector("a");

        largeCircleTitle.innerText = title;
        largeCirclePhase.innerText = phase;
        largeCircleContent.innerHTML = content;

        if (link) {
            largeCircleLink.href = link.href;
            largeCircleLink.innerText = link.innerText;
        } else {
            largeCircleLink.href = "#";
            largeCircleLink.innerText = "";
        }
    }

    function showLargeCircle(circle) {
        // console.log(document.querySelector(".m-circle-extend.active"));
        circleWrapper.querySelector(".m-circle-extend.active")?.classList.remove("active");
        circle.classList.add("active");
        if (!largeCircle.classList.contains("visible")) {
            setTimeout(() => {
                largeCircle.classList.add("visible");
            }, 300)

            // anime({
            //     targets: largeCircle,
            //     scale: [0.5, 1],
            //     opacity: [0, 1],
            //     duration: 1500,
            //     easing: "easeOutQuad",
            // });
        }
    }
});



// PARTNERS slider
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".o-partners__slider").forEach((slider, index) => {
        const logoWidth = slider.querySelector(".o-partners__slider__logo").offsetWidth;
        const containerWidth = slider.offsetWidth;

        const swiperSlides = slider.querySelectorAll(".swiper-slide");
        swiperSlides.forEach(slide => {
            slide.style.width = `${logoWidth}px`;
        });

        const slidesPerView = Math.floor(containerWidth / logoWidth);

        const swiperWrapper = slider.querySelector(".swiper-wrapper");
        const originalSlides = Array.from(swiperWrapper.children);

        if (originalSlides.length > 1) {
            swiperWrapper.insertBefore(originalSlides[originalSlides.length - 1], originalSlides[0]);
        }

        const numDuplicates = Math.ceil(slidesPerView / originalSlides.length) + 1;

        for (let i = 0; i < numDuplicates; i++) {
            originalSlides.forEach(slide => {
                swiperWrapper.appendChild(slide.cloneNode(true));
            });
        }

        const swiperPartners = new Swiper(slider, {
            loop: true,
            slidesPerView: slidesPerView,
            breakpoints: {
                0: {
                    spaceBetween: 17,
                },
                992: {
                    spaceBetween: 24,
                },
            },
        });

        let isScrolling = false;

        slider.addEventListener('wheel', (event) => {
            if (isScrolling) return;
            isScrolling = true;
            event.preventDefault();

            const direction = event.deltaY > 0 ? 1 : -1;

            if (direction > 0) {
                swiperPartners.slideNext();
            } else {
                swiperPartners.slidePrev();
            }

            setTimeout(() => {
                isScrolling = false;
            }, 300);
        });
    });
});



// TEAM slider
const teamSwipers = document.querySelectorAll('.swiper-team');
teamSwipers.forEach((swiperElement) => {
    new Swiper(swiperElement, {
        slidesPerView: 1.25,
        grabCursor: true,
        centeredSlides: true,
        pagination: {
            el: swiperElement.querySelector('.swiper-team-pagination'),
        },
        breakpoints: {
            992: {
                slidesPerView: 3,
                centeredSlides: false
            }
        }
    });
});



// STORY SLIDER
const storySwipers = document.querySelectorAll('.swiper-story');
storySwipers.forEach((swiperElement) => {
    new Swiper(swiperElement, {
        slidesPerView: 1,
        grabCursor: true,
        autoHeight: true,
        speed: 500,
        pagination: {
            el: swiperElement.querySelector('.swiper-story-pagination'),
            clickable: true,
        },
    });
});



// ARTICLES SLIDER
if (window.innerWidth < 992) {
    const articlesSwipers = document.querySelectorAll('.swiper-articles-container');
    articlesSwipers.forEach((swiperElement) => {
        new Swiper(swiperElement, {
            slidesPerView: 1.25,
            spaceBetween: 12,
            centeredSlides: true,
            centeredSlidesBounds: true,
            grabCursor: true,
            breakpoints: {
                0: {
                    slidesPerView: 1.25
                },
                576: {
                    slidesPerView: 1.5
                },
                768: {
                  slidesPerView: 1.75,
                },
            },
        });
    });
}


// open the link in menu item that contain dropdown
document.addEventListener("DOMContentLoaded", function () {
    var dropdownLinks = document.querySelectorAll(".dropdown-toggle");
    dropdownLinks.forEach(function (link) {
        link.addEventListener("click", function (event) {
            window.location.href = this.href;
        });
    });
});



// SCROLLYTELLING slider
if (window.innerWidth < 992) {
    const scrollytellingSwipers = document.querySelectorAll('.swiper-scrollytelling');
    scrollytellingSwipers.forEach((swiperElement) => {
        new Swiper(swiperElement, {
            slidesPerView: 1.25,
            centeredSlides: true,
            loop: true,
            grabCursor: true,
            autoHeight: true,
            pagination: {
                el: swiperElement.querySelector('.swiper-pagination'),
            },
        });
    });
}



// FILTER slider
if (window.innerWidth < 992) {
    const filterSwipers = document.querySelectorAll('.swiper-filter-container');
    filterSwipers.forEach((swiperElement) => {
        new Swiper(swiperElement, {
            slidesPerView: 1.25,
            spaceBetween: 12,
            centeredSlides: true,
            centeredSlidesBounds: true,
            grabCursor: true,
            breakpoints: {
                0: {
                    slidesPerView: 1.25
                },
                576: {
                    slidesPerView: 1.5
                },
                768: {
                    slidesPerView: 1.75,
                },
            },
        });
    });
}



// AOS animation delay for "m-case"  -  Cases CE
document.addEventListener('DOMContentLoaded', function () {
    const cases = document.querySelectorAll('.m-case');
    cases.forEach((caseElement, index) => {
        caseElement.setAttribute('data-aos-delay', (index + 1) * 200);
    });
});



// AOS animation delay for "accordion-item"  -  Accordions CE
document.addEventListener('DOMContentLoaded', function () {
    const cases = document.querySelectorAll('.accordion-item');
    cases.forEach((caseElement, index) => {
        caseElement.setAttribute('data-aos-delay', (index + 1) * 100);
    });
});



// AOS animation delay for "o-four-circles__wrapper__circle"  -  Four circles CE
document.addEventListener('DOMContentLoaded', function () {
    const cases = document.querySelectorAll('.o-four-circles__wrapper__circle');
    cases.forEach((caseElement, index) => {
        caseElement.setAttribute('data-aos-delay', (index + 1) * 200);
    });
});



// AOS animation delay for ".o-team__slider .swiper-slide"  -  Team CE
// document.addEventListener('DOMContentLoaded', function () {
//     const slides = document.querySelectorAll('.o-team__slider .swiper-slide');
//     slides.forEach((slide, index) => {
//         const person = slide.querySelector('.m-person');
//         if (person) {
//             person.setAttribute('data-aos-delay', (index + 1) * 200);
//         }
//     });
// });



// AOS animation delay for ".o-filter .m-article"  -  Filter CE
document.addEventListener('DOMContentLoaded', function () {
    const cases = document.querySelectorAll('.o-filter .m-article');
    cases.forEach((caseElement, index) => {
        // Reset the delay every 3 items (every new row)
        const delayIndex = index % 3;
        caseElement.setAttribute('data-aos-delay', (delayIndex + 1) * 200);
    });
});



// AOS animation delay for ".o-articles .m-article"  -  Articles CE
document.addEventListener('DOMContentLoaded', function () {
    const cases = document.querySelectorAll('.o-articles .m-article');
    cases.forEach((caseElement, index) => {
        // Reset the delay every 3 items (every new row)
        const delayIndex = index % 3;
        caseElement.setAttribute('data-aos-delay', (delayIndex + 1) * 200);
    });
});



// GSAP animation for Two columns CE
gsap.registerPlugin(ScrollTrigger);
window.addEventListener("load", function () {
    if (window.innerWidth > 991) {
        // TWO COLUMNS
        document.querySelectorAll(".o-two-columns .f-l").forEach((el) => {
            gsap.from(el, {
                duration: 6,
                opacity: 0,
                y: 100,
                ease: "power4.out",
                scrollTrigger: {
                    trigger: el,
                    start: "top 90%",
                    end: "top top",
                    scrub: true
                }
            });
        });
        document.querySelectorAll(".o-two-columns .h2 p").forEach((el) => {
            gsap.from(el, {
                duration: 6,
                delay: 5,
                opacity: 0,
                y: 200,
                ease: "power4.out",
                scrollTrigger: {
                    trigger: el,
                    start: "top 90%",
                    end: "top top",
                    scrub: true
                }
            });
        });
        document.querySelectorAll(".o-two-columns .col-lg-5:first-of-type").forEach((el) => {
            gsap.from(el, {
                duration: 6,
                opacity: 0,
                y: 50,
                ease: "power4.out",
                scrollTrigger: {
                    trigger: el,
                    start: "top 80%",
                    scrub: true
                }
            });
        });
        document.querySelectorAll(".o-two-columns .col-lg-5:nth-of-type(2)").forEach((el) => {
            gsap.from(el, {
                duration: 6,
                opacity: 0,
                y: 50,
                ease: "power4.out",
                scrollTrigger: {
                    trigger: el,
                    start: "top 70%",
                    scrub: true
                }
            });
        });
        document.querySelectorAll(".o-two-columns .m-circle").forEach((el) => {
            gsap.from(el, {
                duration: 5,
                opacity: 0,
                y: 100,
                ease: "power4.out",
                scrollTrigger: {
                    trigger: el,
                    start: "top 70%",
                    scrub: true
                }
            });
        });

        // BANNER
        document.querySelectorAll(".o-banner").forEach((el) => {
            gsap.to(el, {
                opacity: 0.3,
                ease: "power1.out",
                scrollTrigger: {
                    trigger: el,
                    start: "bottom 80%",
                    end: "bottom top",
                    scrub: 1
                }
            });
        });

        // STORYTELLING
        document.querySelectorAll(".o-storytelling__wrapper__content").forEach((el) => {
            gsap.from(el, {
                duration: 5,
                delay: 5,
                opacity: 0.4,
                ease: "power4.out",
                scrollTrigger: {
                    trigger: el,
                    start: "top bottom",
                    scrub: true
                }
            });
        });

        // HEADING WITH CTA
        const elements = [
            { selector: ".o-heading-with-cta h1", delay: 0 },
            { selector: ".o-heading-with-cta h3", delay: 0.2 },
            { selector: ".o-heading-with-cta__content", delay: 0.4 },
            { selector: ".o-heading-with-cta a.btn", delay: 0.6 }
        ];
        elements.forEach((el) => {
            gsap.from(el.selector, {
                duration: 1.5,
                opacity: 0,
                y: -50,
                ease: "power4.out",
                delay: el.delay
            });
        });

        // TEXT WITH GRAPH
        document.querySelectorAll(".o-text-with-graph .h2 p").forEach((el) => {
            gsap.from(el, {
                duration: 6,
                delay: 5,
                opacity: 0,
                y: 100,
                ease: "power4.out",
                scrollTrigger: {
                    trigger: el,
                    start: "top 90%",
                    end: "top top",
                    scrub: true
                }
            });
        });
        document.querySelectorAll(".o-text-with-graph__content").forEach((el) => {
            gsap.from(el, {
                duration: 6,
                opacity: 0,
                y: 100,
                ease: "power4.out",
                scrollTrigger: {
                    trigger: el,
                    start: "top 80%",
                    scrub: true
                }
            });
        });
        document.querySelectorAll(".o-text-with-graph__big-circle").forEach((el) => {
            gsap.from(el, {
                duration: 5,
                opacity: 0,
                y: 150,
                ease: "power4.out",
                scrollTrigger: {
                    trigger: el,
                    start: "top 70%",
                    scrub: true
                }
            });
        });
    }
});


document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('a[href*="#"]').forEach(function (anchor) {
        anchor.addEventListener("click", function (e) {
            var href = this.getAttribute("href");
            e.preventDefault();

            var targetId = href.split("#")[1];
            var targetElement = document.getElementById(targetId);

            if (targetElement) {
                var offsetTop = targetElement.offsetTop - 130;

                window.scrollTo({
                    top: offsetTop,
                    behavior: "smooth"
                });
            }
        });
    });
});